// extracted by mini-css-extract-plugin
module.exports = {"shareWidget":"share-widget-module--share-widget--2xdrX","shareWidgetActive":"share-widget-module--share-widget-active--136-E"};